module.exports = __webpack_public_path__ + "static/screen1-172696a4f040a1c58989a308b1e38e0a.png";